<app-schedule-list (mySelected)='list_onSelected($event)'></app-schedule-list>